import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { DepotLayout } from './DepotLayout';
import type { DepotBrandingDto } from '../types';

interface Props {
  uploadedCount: number;
  /** Habillage courtier/produit (cohérence visuelle jusqu'au bout). */
  branding?: DepotBrandingDto;
}

/**
 * Écran final affiché après /confirmer. Le token est mort côté back :
 * on ne propose volontairement aucun bouton qui referait un appel, et le
 * texte rappelle au souscripteur ce qu'il vient de faire pour rassurer.
 */
export const DepotThanksScreen: React.FC<Props> = ({
  uploadedCount,
  branding
}) => (
  <DepotLayout branding={branding}>
    <div className="flex flex-col items-center text-center gap-5">
      <div className="bg-green-50 rounded-full p-4">
        <CheckCircle2
          className="w-16 h-16 text-green-500"
          strokeWidth={2}
        />
      </div>
      <h1 className="text-2xl font-bold text-gray-800">Merci !</h1>
      <p className="text-gray-600 leading-relaxed">
        Votre dépôt a bien été confirmé.{' '}
        {uploadedCount > 0 && (
          <>
            <span className="font-medium text-gray-800">
              {uploadedCount} document{uploadedCount > 1 ? 's' : ''}
            </span>{' '}
            transmis à votre courtier.
          </>
        )}
      </p>
      <p className="text-sm text-gray-500">
        Vous pouvez maintenant fermer cet onglet.
      </p>
    </div>
  </DepotLayout>
);
